import { invokeApi } from "../../bl_libs/invokeApi";

export const login_public_branding_api = async (signal = null) => {
  const requestObj = {
    path: `api/general_routes/login_public_branding`,
    method: "GET",
    signal,
    skip401Handler: true,
  };
  return invokeApi(requestObj);
};

export const upload_general_image_api = async (data) => {
  const requestObj = {
    path: `api/general_routes/upload_image`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const upload_multiple_images_api = async (data) => {
  const requestObj = {
    path: `api/general_routes/upload_multiple_images`,
    method: "POST",
    postData: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return invokeApi(requestObj);
};

export const upload_audio_from_mobile_api = async (data) => {
  const requestObj = {
    path: `api/general_routes/upload_audio_from_mobile`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const web_consoles_api = async (data) => {
  const requestObj = {
    path: `api/general_routes/web_consoles`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

/** Server-side Open Graph link preview (chat / feeds). Requires auth cookie. */
export const link_preview_api = async (url, signal = null) => {
  const requestObj = {
    path: `api/general_routes/link_preview`,
    method: "GET",
    queryParams: { url },
    signal,
  };
  return invokeApi(requestObj);
};
